module.exports = {"632724100":"加吉博洛格镇","632724200":"索加乡","632724201":"扎河乡","632724202":"多彩乡","632724203":"治渠乡","632724204":"立新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632724.json
// module id = 2801
// module chunks = 0